import React from "react"
import PropTypes from "prop-types"
import { countResults } from "../../helpers/sharedHelperFunctions"
import "./AssetFilters.scss"

const AssetFilters = props => {
  const results = props.filteredResults.slice().sort((a, b) => {
    if (
      a.item.assetDeviceType.name.toLowerCase() <
      b.item.assetDeviceType.name.toLowerCase()
    )
      return -1
    if (
      a.item.assetDeviceType.name.toLowerCase() >
      b.item.assetDeviceType.name.toLowerCase()
    )
      return 1
    return 0
  })

  const resultCounts = countResults(results.map(r => r.item.assetDeviceType.id))
  const deviceTypeIdToName = {}
  results.forEach(r => {
    deviceTypeIdToName[r.item.assetDeviceType.id] = r.item.assetDeviceType.name
  })

  const filtersSelected =
    props.selectedAssetFilters && props.selectedAssetFilters.length > 0

  if (filtersSelected) {
    props.selectedAssetFilters.forEach(selectedFilter => {
      if (!resultCounts[selectedFilter]) {
        resultCounts[selectedFilter] = 0
      }
    })
  }

  const displaySortedDeviceTypes = () => {
    const sortableArray = []

    Object.keys(deviceTypeIdToName).forEach(key => {
      sortableArray.push([key, deviceTypeIdToName[key]])
    })

    sortableArray.sort((a, b) => {
      if (a[1].toLowerCase() < b[1].toLowerCase()) {
        return -1
      } else if (a[1].toLowerCase() > b[1].toLowerCase()) {
        return 1
      } else {
        return 0
      }
    })

    return sortableArray.map(deviceIdAndName => {
      const id = deviceIdAndName[0]
      const name = deviceIdAndName[1]

      return (
        <div key={id} className="filter-option">
          <input
            type="checkbox"
            id={id}
            onChange={props.onChange}
            value={id}
            checked={props.selectedAssetFilters.includes(id)}
          />
          <label htmlFor={id}>
            {name} ({resultCounts[id]})
          </label>
        </div>
      )
    })
  }

  return (
    <div className="AssetFilters">
      <div className="filter-header">
        <div>DEVICE TYPES</div>
        {props.deviceType === "desktop" ? (
          <button
            className="reset"
            onClick={props.onReset}
            type="reset"
            hidden={!filtersSelected}
          >
            <font size="1">RESET</font>
            <strong> x</strong>
          </button>
        ) : null}
      </div>
      <div className="asset-checkboxes">{displaySortedDeviceTypes()}</div>
    </div>
  )
}

AssetFilters.propTypes = {
  filteredResults: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.shape({
        assetDeviceType: PropTypes.shape({
          name: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
        }),
      }),
    })
  ),
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  selectedAssetFilters: PropTypes.array,
  deviceType: PropTypes.string.isRequired,
}

AssetFilters.defaultProps = {
  selectedAssetFilters: [],
}

export default AssetFilters
